// Tiny module-scope reactive store shared between the chat assistant and the
// quote page (pinia is not installed). The chat can push a DIY draft or a
// quote-prefill here, then navigate to /quote where QuoteView seeds its form.
import { reactive } from 'vue'

export const quoteDraft = reactive({
  draft: null, // DiyDraft object or null — shown as a removable summary chip
  productInterests: [], // string[] of product ids to pre-check
  message: '' // prefilled requirements text
})

// Attach a confirmed DIY draft to the pending quote.
export function attachDraft(d) {
  quoteDraft.draft = d ? { ...d } : null
}

export function clearDraft() {
  quoteDraft.draft = null
}

// Apply a quote_prefill action's fields.
export function applyPrefill(fields) {
  if (!fields || typeof fields !== 'object') return
  if (Array.isArray(fields.productInterests)) {
    quoteDraft.productInterests = fields.productInterests.filter((s) => typeof s === 'string')
  }
  if (typeof fields.message === 'string') {
    quoteDraft.message = fields.message
  }
}

// Reset the prefill (form seed) fields — called by QuoteView after seeding so a
// later manual visit starts clean. The attached draft persists until removed.
export function clearPrefill() {
  quoteDraft.productInterests = []
  quoteDraft.message = ''
}
